<template>
  <div class="sion-personnel people_tran_all_checked" v-loading.fullscreen.lock="loading">
  
    <div class="sino-panel">
      <!-- 头部 -->
      <top-part :rightPart="true"></top-part>
      <!-- 头部 结束 -->
      <div class="panel-top">
        <el-input
          placeholder="请输入关键字搜索"
          @input="search"
          v-model="seach">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <!-- <div class="search-btn" @click="search">搜索</div> -->
      </div>

      <div class="panel-content">
        <template>
          <div class="panel-scroll">
            <!-- 分会list -->
            <div class="scroll-aside">
              <div
                :class="['aside-item',item.active?'item-active':'']"
                v-for="(item,index) in officeData"
                :key="index"
                @click="selectOffice(index)"
                v-if="item.hasStaff"
              >
                  <span class="management-name">{{item.name}}</span>
                  <span>({{item.checkedLen}})</span>
              </div>
            </div>
            <!-- 分会list -->
            <!-- 科室list -->
             <div class="scroll-aside" ref="asideSecond" style="background:#FFF">
              <div
                :class="['aside-item',item.active?'item-active':'']"
                v-for="(item,index) in currentDepartmentList"
                :key="index"
                @click="selectDept(index)"
                v-if="item.hasStaff"
              >
                  <span class="management-name">{{item.name}}</span>
                  <span>({{item.checkedLen}})</span>                
              </div>
            </div>
            <!-- 科室list 结束 -->

            <div class="scroll-panel" ref="scrollView">
              <!-- 多选 -->
              <div
                class="panel-item"
                v-for="item in staffListData.slice(0,currentData)"
                :key="item.id"
                >
                <div class="item_people">
                  <div class="item_flex_all">
                    <div class="item_flex">
                      <img v-if="item.photo" :src="item.photo" alt />
                      <img v-else src="@/images/doctor.png" alt srcset />
                      <div class="info-name">{{item.name}}</div>
                    </div>
                    <img src="@/images/close.png" alt srcset @click="delPeople(item)" />
                  </div>
                  <div class="info-number">性别:{{item.sex == "2" ? "女" : "男"}}</div>
                  <div class="info-number" @click="callTel(item.phone)">手机号:<span>{{item.phone}}</span></div>
                </div>
              </div>
             
              <div
                class="load-more mr-bottom"
                v-if="currentData<staffListData.length"
                @click="loadMore"
              >点击加载更多</div>
              <div class="load-more mr-bottom" v-else>没有更多了</div>

            </div>
          </div>
        </template>
      </div>


      <div class="sino-footer">
        <div class="footer-box transfer" @click="selectOK">确定</div>
      </div>    

    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import topPart from "../../components/topPart";
import {
  officeTreeData,
  getAppStaffListData,
  officeTransfer
} from "@/common/api";
export default {
  data() {
    return {
      allCheck: false,
      seach: "",
      loading: false,
      currentData: 20,
      officeData: [],
      activeData: [],
      staffListData: [],
      currentDepartment: "",
      unionId: JSON.parse(localStorage.getItem("loginInfo")).unionId,
      option: {
        label: ""
      },
      options:{

      },
      selected:"",
      selectedPerson:"",
      currentDepartmentList:[],//当前选中的分会下的科室
      currentUnionIndex:0,//当前选中的分会索引
      currentDeptIndex:0,//当前选中的科室索引
    };
  },
  components: {
    topPart
  },
  watch: {
    allCheck(value) {
      this.staffListData.forEach(item => {
        if (value) item.check = true;
        else item.check = false;
      });
    },
    seach(value) {
      if (!value) {
        this.getAppStaffList(this.currentUnionIndex,this.currentDeptIndex);
      }
    }
  },
  created() {
    this.getOfficeTree();
    // this.getAppStaffList();
  },
  methods: {
    selectOK(){    
      sessionStorage.setItem("checkedStaffList",JSON.stringify(this.officeData));
      this.$router.go(-1);
    },
    getOfficeTree() {
      let arr = sessionStorage.getItem("checkedStaffList");
      arr=JSON.parse(arr);
      arr&&arr.length&&arr.forEach(item=>{
        item.active=false;
        var length = 0;
        item.children&&item.children.length&&item.children.forEach((item2,index)=>{
          item2.active=false;
          if(item2.staffList&&item2.staffList.length){
            if(index==0)length = item2.staffList.length;
            item.hasStaff=true;
            item2.hasStaff=true;
            item2.checkedLen = item2.staffList.length;
          }
        })
        item.checkedLen = length;
      })

      arr[0].active=true;
      arr[0].children[0].active=true;
      this.currentDepartmentList=arr[0].children;
      // 默认选中第一个
      this.officeData = arr;
      this.getAppStaffList(0,0);
    },
    loadMore() {
      this.currentData += 20;
    },
    getAppStaffList(index1, index2, name) {
      let staffList= this.officeData[index1].children[index2].staffList;
      this.staffListData=staffList||[];
      if(name){
        // 模糊查询
        let arr = [];
        staffList&&staffList.length&&staffList.forEach(item=>{
          if(item.name.indexOf(name)!=-1)arr.push(item);
        })
       this.staffListData=arr;
      }
    },
    // 点击分会
    selectOffice(index) {
      this.currentUnionIndex=index;
      this.$refs.asideSecond.scrollTop = 0
      this.officeData.forEach(item => {
        item.active = false;
      });
      let item = this.officeData[index];
      item.active = true;
      this.currentDepartment = item.id;
      this.currentDepartmentList=item.children;
      this.selectDept(0)
    },
    // 点击科室
    selectDept(index){
      this.currentDeptIndex=index;
      this.currentData = 20
      this.$refs.scrollView.scrollTop = 0
      this.currentDepartmentList.forEach(item => {
        item.active = false;
      });
      let item = this.currentDepartmentList[index];
      item.active = true;
      this.getAppStaffList(this.currentUnionIndex,index);
      this.currentDepartment = item.id;
    },
    // 删除人员
    delPeople(staff){
      let _index1 = this.officeData.findIndex((item)=>{return staff.unionId==item.id});
      let _index2 = this.officeData[_index1].children.findIndex((item)=>{return staff.deptId==item.id});
      _index1=_index1<0?0:_index1;
      _index2=_index2<0?0:_index2;
      this.delAll(_index1,_index2,staff);
      this.delAll(_index1,0,staff);
      if((_index1!=0&&_index2!=0)||staff.deptId=="")this.delAll(0,0,staff)
      
    },
    delAll(_index1,_index2,staff){
      let list = this.officeData[_index1].children[_index2];
      list.staffList.forEach((item,index)=>{
        if(item.id==staff.id) list.staffList.splice(index,1)
      })
      let list_second = this.officeData[_index1].children;
      // 当前人员删到最后一个
      if(!list.staffList.length){
        list.hasStaff=false;
        // 当前科室active置为false
        var count=0;
        for (let i = 0;i<list_second.length;i++) {
          let item = list_second[i];
          if(item.hasStaff){
            count++;
            item.active=true;
            this.selectDept(i)
            break;
          }
        }
        // 当前分会active置为false
        if(count==0) {
          this.officeData[_index1].hasStaff=false;
          var count1=0;
          for (let i = 0;i<this.officeData.length;i++) {
            let item = this.officeData[i];
            if(item.hasStaff){
              count1++;
              item.active=true;
              this.selectOffice(i)
              break;
            }
          }
          // 分会删完的时候
          if(count1===0){
            sessionStorage.removeItem('checkedStaffList'); 
            this.$router.go(-1);
          }
        }
      }
      this.calcLength();
    },
    calcLength(){
      this.officeData&&this.officeData.length&&this.officeData.forEach(item=>{
        var length = 0;
        item.children&&item.children.length&&item.children.forEach((item2,index)=>{
          if(item2.staffList&&item2.staffList.length){
            if(index==0)length = item2.staffList.length;
            item2.checkedLen = item2.staffList.length;
          }
        })
        item.checkedLen = length;
      })
    },
    close() {
      document.getElementsByTagName("body")[0].setAttribute("style", "");
    },
    //模糊搜索
    search() {
      if (this.seach) this.getAppStaffList(this.currentUnionIndex,this.currentDeptIndex,this.seach);
    },
    callTel(tel) {
      if (!tel) return;
      let telNode = document.createElement("a");
      telNode.style.display = "none";
      telNode.href = "tel:" + tel;
      telNode.click();
    },
    getPersonDetail(option) {
      this.$router.push({
        path: "/persinnelDetail",
        query: {
          id: option.id
        }
      });
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/common.styl';
.people_tran_all_checked{
  .item_people {
    width: 90%;
    border-bottom: 1px solid #E5E5E5;
    .item_flex_all {
      display: flex;
      justify-content: space-between;
    }
    .item_flex {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      >img {
        margin-right:10px;
      }
    }
    img {
      width:23px;
      height:23px;
    }
    .info-number {
      font-size:13px;
      font-family:PingFang SC;
      font-weight:500;
      color:rgba(153,153,153,1);
      line-height: 20px;
    }
    .info-name {
      font-size:15px;
      font-family:PingFang SC;
      font-weight:500;
      color:rgba(53,53,53,1);
      line-height: 20px;
      width: 60px;
      ellipsis();
    }
  }
  .cube-checkbox-ui {
    margin-top: 20px;
  }
  .top-box {
    justify-content: space-between;
  }
  .people_top {
    display: flex;
    align-items: center;
    margin-right: 16px;
    img {
      width: 18px; 
      margin-right: 4px;
    }
    span {
      font-size:14px;
      font-family:PingFang SC;
      font-weight:500;
      color:rgba(41,189,187,1);
    }
  }
  .el-message--success{
    background-color: #fff !important;
    border-color: #e2e2e2 !important;
  }
  .el-message{
    min-width:100px !important;
    max-width:80%;
  } 
  .person{
    width:80% !important;
    .person-block{
      display:flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: row;
    }
    > i.el-message,
    > i.el-icon-success {
      display: none;
    }
    p.title,
    p.success {
      color: #000 !important;
    }
    p.fail {
      color: red !important;
    }
    i {
      display: inline-block;
      margin-right: 5px;
    }
    .msg {
      margin-bottom: 10px;
    }
  }
  .mr-bottom {
    text-align: center;
    font-size: 14px;
    color: #38c7c4;
    padding: 10px 0;
  }

  .sino-footer {
    border-top: 1px solid #E5E5E5;
    .election {
      flex: 5;

      .cube-checkbox-wrap {
        width: 40%;
      }
    }

    .transfer {
      flex: 2;
      background: rgba(56, 199, 196, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);

      &:active {
        background: rgba(56, 199, 196, 0.5);
      }
    }

    .footer-box {
      height: 100%;
    }
  }

  .panel-top {
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    padding: 0 0.6rem;
    padding-top: 40px;

    .search-btn {
      width: 40px;
      margin-left: 0.5rem;
      color: #999;
      white-space: nowrap;
    }

    .el-input__inner {
      background: #EFEFF4;
      border: none;
      height: 32px;
      border-radius: 16px;
      background: rgba(239, 239, 244, 1);
    }

    .el-input__icon{
      line-height: 32px;
    }
    // input::-webkit-input-placeholder{
    //   line-height: 32px !important;
    // }
    input{
      padding: 8px 0.8rem !important;
      height: 34px !important;
      font-size: 14px !important;
      line-height: 14px !important;
    }
  }

  .panel-content {
    height:calc(100vh - 100px - 59px);
    overflow-y:scroll;
    .panel-scroll {
      height: 100%;
      display: flex;
      .scroll-aside {
        height: 100%;
        overflow: auto;
        flex: 2.5;
        .aside-item {
          text-align: center;
          // height: 60px;
          padding:10px;    
          display:flex;
          flex-direction:column;
          justify-content:center;
          align-items:center;    
        }

        .item-active {
          background: #ffffff !important;
          color: #29BDBB;
        }
      }
      .scroll-aside:nth-child(2){
        border-right: 1px solid #E5E5E5;
      }
      .scroll-panel {
        flex: 5;
        height: 100%;
        overflow: auto;
        background: #fff;

        .panel-item {
          display: flex;
          height: 71px;
          padding: 0.15rem 0;
          background: #ffffff;
          justify-content:flex-start;
          align-items: center;
          margin-left:10px;
          .item-radio {
            display: flex;
            align-items: center;
            width:46px;
            .cube-checkbox {
              padding: 0 0 0 0.16rem;
            }
          }
          .item-phone {
            display: flex;
            align-items: center;
            width:60px;
            height:60px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .item-info {
            flex: 1;
            margin-left: 0.3rem;
            .info-name {
              height: 30px;
              line-height: 30px;
              font-size: 16px;
              font-weight: 400;
              color: rgba(53, 53, 53, 1);
            }

            .info-number {
              height: 20px;
              line-height: 20px;
              color: rgba(153, 153, 153, 1);
              font-size: 14px;
            }
          }
        }
      }
    }
  }

  .cube-radio-wrap{
    .cube-radio-ui{
      font-size:22px;
    }
  }

  .cube-action-sheet-list {
    height: 151px;
    overflow: auto;
    touch-action: auto;
  }

  .cube-action-sheet-space {
    height: 0.03rem;
  }

  .cube-action-sheet-title {
    background: rgba(232, 232, 241, 1);
    color: rgba(136, 136, 136, 1);
    height: 0.2rem;
    line-height: 0.2rem;
    font-size: 15px;
  }

  .management-name {
    display: inline-block;
    line-height:18px;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // overflow: hidden;
    font-size:14px;

  }
 
}
</style>